<template>
  <div id="admin">
    <LoginDialog :dialogVisible="dialogLoginVisible" @close="dialogLoginVisible = false" />
    <div class="platform-menu" :style="{'width': platformSize + 'px'}">
      <el-menu :collapse="platformCollapse" :default-openeds="['1']">
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-user"></i>
            <span v-show="!platformCollapse">主体账号</span>
          </template>
          <el-menu-item-group v-if="platformUserList && platformUserList.length">
            <el-menu-item
              v-for="item in platformUserList"
              :key="item.value + '_' + item.id"
              :index="item.value + '_' + item.id"
              @click="toggleUser(item)"
              :class="{'platform-active': isPlatformCurrent(item)}">
                {{item.label}}--{{item.username}}
              </el-menu-item>
            <el-menu-item
              index="loginAdd"
              @click="loginAdd()">
                添加账号
              </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
      <div
        class="arrow"
        @click="platformCollapse = !platformCollapse"
      >
        <i class="el-icon-arrow-left"></i>
      </div>
    </div>
    <el-container style="width: 100vw; height: 100vh; overflow-x: hidden" v-if="platformUserList && platformUserList.length">
      <el-dialog
        title="超级管理员"
        :visible.sync="dialogVisible"
        width="30%">
        <el-table
          :data="superAdminList"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="phonenum"
            label="手机号"
            :formatter="(row, column, cellValue, index) => {
              return cellValue && cellValue.replace(/^(\d{3})\d*(\d{4})$/, '$1****$2')
            }">
          </el-table-column>
          <el-table-column label="获取授权">
            <template slot-scope="scope">
              <el-button
                size="mini"
                :disabled="smsSending"
                @click="sendSms(scope.row.phonenum, scope.$index)">
                {{smsSending && currentIndex === scope.$index ? sendCount + 's后重发' : '发送验证码'}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog
        title="请输入验证码"
        :visible.sync="dialogSmsVisible"
        :modal="true"
        :close-on-click-modal="false">
        <el-form>
          <el-form-item label="验证码:" required>
            <el-input v-model="currentAdmin.code"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogSmsVisible = false">取 消</el-button>
          <el-button type="primary" @click="getSuperToken">确 定</el-button>
        </div>
      </el-dialog>
      <el-header class="menu-hd">
        <div
          class="hd-main"
          :style="{ left: platformSize + 'px', width: `calc(100% - ${platformSize}px)` }">
          <span class="logoFont">{{ logoText }}</span>
          <div style="display: flex;">
            <div v-show="exportDownloadPercent">
              <span class="admin" style="color: #e0f7fa;">导出进度：{{ exportDownloadPercent }}%</span>
            </div>
            <span class="admin">{{ currentPlatformUser.username }}</span>
            <el-dropdown :show-timeout="0">
              <i class="el-icon-setting admin-setting"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="changeShowGamePackagesUploadTasks(true)"
                  icon="el-icon-upload"
                  >游戏包上传任务</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="dialogVisible = true"
                  icon="el-icon-medal"
                  v-if="showSuperRole"
                  >获取超级授权</el-dropdown-item
                >
                <el-dropdown-item @click.native="logout" divided icon=""
                  >退出</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>
      <el-container v-if="showContainer" :style="{ height: setHeight + 'px' }">
        <div class="menu-left" :style="{ left: platformSize + 'px' }">
          <div
            class="el-sider-trigger"
            @click="zoom()"
            :style="{ width: size + 'px', left: platformSize + 'px' }"
          >
            <i class="el-icon-arrow-left"></i>
          </div>
          <el-menu
            :default-active="String(activeNav)"
            router
            class="el-menu-vertical-demo aside-left"
            :collapse="isCollapse"
            @select="handleSelect"
          >
            <el-menu-item index="/home">
              <i class="el-icon-setting"></i>
              <span slot="title">首页</span>
            </el-menu-item>

            <el-submenu v-if="hasPermission('用户管理')" index="2">
              <template slot="title">
                <i class="el-icon-user-solid"></i>
                <span slot="title">用户管理</span>
              </template>

              <el-menu-item index="/home/users" v-if="hasPermission('用户列表')"
                >用户列表</el-menu-item
              >

              <el-menu-item index="/home/device" v-if="hasPermission('新增用户设备信息')"
                >新增用户设备信息</el-menu-item
              >

              <el-menu-item index="/home/deviceActivate" v-if="hasPermission('用户设备列表')"
                >用户设备列表</el-menu-item
              >

              <el-menu-item index="/home/roles" v-if="hasPermission('角色列表')"
                >角色列表</el-menu-item
              >

              <el-menu-item
                index="/home/rebateMonitor"
                v-if="hasPermission('返利标记用户数据列表')"
                >返利标记用户数据列表</el-menu-item
              >

            </el-submenu>
            <el-submenu v-if="hasPermission('权限管理')" index="3">
              <template slot="title"> 
                <i class="el-icon-user-solid"></i>
                <span slot="title">员工管理</span>
              </template>

              <el-menu-item
                index="/home/privilegeList"
                v-if="hasPermission('权限列表')"
                >权限列表</el-menu-item
              >
              <el-menu-item
                index="/home/staff"
                v-if="hasPermission('员工管理')">员工管理</el-menu-item>
            </el-submenu>
            <el-submenu v-if="hasPermission('订单管理')" index="4">
              <template slot="title">
                <i class="el-icon-s-order"></i>
                <span slot="title">订单管理</span>
              </template>

              <el-menu-item index="/home/orders" v-if="hasPermission('订单列表')"
                >订单列表</el-menu-item
              >
            </el-submenu>
            <el-submenu v-if="hasPermission('游戏管理')" index="5">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">游戏管理</span>
              </template>

              <el-menu-item index="/home/games" v-if="hasPermission('游戏列表')"
                >游戏列表</el-menu-item
              >

              <el-menu-item
                index="/home/gamePackage"
                v-if="hasPermission('游戏包列表')"
                >游戏包列表</el-menu-item
              >
            </el-submenu>
            <el-submenu v-if="hasPermission('渠道管理')" index="6">
              <template slot="title">
                <i class="el-icon-attract"></i>
                <span slot="title">渠道管理</span>
              </template>

              <el-menu-item index="/home/channel" v-if="hasPermission('渠道列表')"
                >渠道列表</el-menu-item
              >

              <el-menu-item
                index="/home/channelPackage"
                v-if="hasPermission('渠道包列表')"
                >渠道包列表</el-menu-item
              >
              <el-menu-item
                index="/home/channelGroup"
                v-if="hasPermission('渠道包组列表')"
                >渠道包组列表</el-menu-item
              >
            </el-submenu>
            <el-submenu v-if="hasPermission('预付管理')" index="7">
              <template slot="title">
                <i class="el-icon-potato-strips"></i>
                <span slot="title">预付管理</span>
              </template>

              <el-menu-item
                v-if="hasPermission('预付池')"
                index="/home/prepaidPool"
                >预付池</el-menu-item
              >
              <el-menu-item
                v-if="hasPermission('返还审核')"
                index="/home/backExamine"
                >返还审核</el-menu-item
              >
            </el-submenu>
            <el-submenu v-if="hasPermission('数据统计管理')" index="8">
              <template slot="title">
                <i class="el-icon-date"></i>
                <span slot="title">数据统计管理</span>
              </template>

              <el-menu-item
                index="/home/recharge"
                v-if="hasPermission('充值排行榜')"
                >充值排行榜</el-menu-item
              >

              <el-menu-item
                index="/home/retention"
                v-if="hasPermission('用户留存统计')"
                >用户留存统计</el-menu-item
              >

              <el-menu-item
                index="/home/userRetention"
                v-if="hasPermission('用户付费留存统计')"
                >用户付费留存统计</el-menu-item
              >

              <el-menu-item
                index="/home/ltv"
                v-if="hasPermission('用户生命周期LTV')"
                >用户生命周期LTV</el-menu-item
              >

              <el-menu-item
                index="/home/report"
                v-if="hasPermission('总数据报表统计')"
                >总数据报表统计</el-menu-item
              >
              <el-menu-item
                index="/home/channelReport"
                v-if="hasPermission('渠道包数据统计')"
                >渠道包数据报表统计</el-menu-item
              >
              <el-menu-item
                index="/home/areaReport"
                v-if="hasPermission('游戏区服报表统计')"
                >游戏区服报表统计</el-menu-item
              >
              <el-menu-item
                index="/home/monthSummary"
                v-if="hasPermission('每月数据汇总')"
                >每月数据汇总</el-menu-item
              >
              <el-menu-item
                index="/home/hourDataReport"
                v-if="hasPermission('分时数据统计')"
                >分时数据统计</el-menu-item
              >
              <el-menu-item
                index="/home/payReport"
                v-if="hasPermission('当日付费详情')"
                >当日付费详情
              </el-menu-item>
              <el-menu-item
                index="/home/payZoneReport"
                v-if="hasPermission('当日区服详情')"
                >当日区服详情
              </el-menu-item>
              <el-menu-item
                index="/home/adDeviceReport"
                v-if="hasPermission('广告设备统计')"
                >广告设备统计</el-menu-item
              >
            </el-submenu>
            <el-submenu v-if="hasPermission('黑名单管理')" index="9">
              <template slot="title">
                <i class="el-icon-document-delete"></i>
                <span slot="title">黑名单管理</span>
              </template>

              <el-menu-item index="/home/blackIp" v-if="hasPermission('IP黑名单')"
                >IP黑名单</el-menu-item
              >

              <el-menu-item
                index="/home/blackPhone"
                v-if="hasPermission('手机黑名单')"
                >手机黑名单</el-menu-item
              >
              <el-menu-item index="/home/blackGdids">设备号黑名单</el-menu-item>
              <el-menu-item index="/home/blackIdNumber" v-if="hasPermission('身份证黑名单')">身份证黑名单</el-menu-item>
              <el-menu-item index="/home/blackUser" v-if="hasPermission('用户黑名单')">用户黑名单</el-menu-item>
            </el-submenu>
            <el-submenu v-if="hasPermission('白名单管理')" index="10">
              <template slot="title">
                <i class="el-icon-document-delete"></i>
                <span slot="title">白名单管理</span>
              </template>
              <el-menu-item index="/home/whitePhone">手机白名单</el-menu-item>
              <el-menu-item index="/home/whiteUser">用户白名单</el-menu-item>
              <el-menu-item index="/home/whiteGdids">设备白名单</el-menu-item>
              <el-menu-item v-if="hasPermission('身份证白名单')" index="/home/whiteIdNumber">身份证白名单</el-menu-item>
              <el-menu-item index="/home/whiteIp">IP白名单</el-menu-item>
            </el-submenu>

            <el-submenu v-if="hasPermission('周期统计')" index="11">
              <template slot="title">
                <i class="el-icon-document-delete"></i>
                <span slot="title">周期统计</span>
              </template>

              <el-menu-item
                index="/home/retainCycleStatistics"
                v-if="hasPermission('留存统计')"
                >留存统计</el-menu-item
              >
              <el-menu-item
                index="/home/ltvCycleStatistics"
                v-if="hasPermission('LTV统计')"
                >LTV统计</el-menu-item
              >
              <el-menu-item
                index="/home/payRetainCycleStatistics"
                v-if="hasPermission('付费留存统计')"
                >付费留存统计</el-menu-item
              >
              <el-menu-item
                index="/home/goodsStatisticsCycle"
                v-if="hasPermission('商品周期统计')"
                >商品周期统计</el-menu-item
              >
              <el-menu-item
                index="/home/goodsStatisticalSummary"
                v-if="hasPermission('商品汇总统计')"
                >商品汇总统计</el-menu-item
              >
              <el-menu-item
                index="/home/deviceLoginLog"
                v-if="hasPermission('渠道登录日志')"
                >渠道登录日志</el-menu-item
              >
              <el-menu-item
                index="/home/channelChangeStatistics"
                v-if="hasPermission('渠道变动统计')"
                >渠道变动统计</el-menu-item
              >
              <el-menu-item
                index="/home/cycleStatistics"
                v-if="hasPermission('周期数据汇总统计')"
                >周期数据汇总统计</el-menu-item
              >
              <el-menu-item index="/home/hourLogin" v-if="hasPermission('分时段登录统计')">分时段登录统计</el-menu-item>
              <el-menu-item
                index="/home/loginStatisticsDay"
                v-if="hasPermission('每天登录统计')"
                >每天登录统计</el-menu-item
              >
              <el-menu-item
                index="/home/lostActiveStatistics"
                v-if="hasPermission('流失活跃统计')"
                >流失活跃统计</el-menu-item
              >
              <el-menu-item
                index="/home/userDevice"
                v-if="hasPermission('用户设备信息')"
                >用户设备信息</el-menu-item
              >
              <el-menu-item
                index="/home/payTop"
                v-if="hasPermission('充值排行榜')"
                >充值排行榜
              </el-menu-item>
              <el-menu-item
                index="/home/levelStatistics"
                v-if="hasPermission('等级留存统计')"
                >等级留存统计
              </el-menu-item>
              <el-menu-item
                index="/home/rfmStatistics"
                v-if="hasPermission('RFM模型管理')"
                >RFM模型管理
              </el-menu-item>
              <el-menu-item
                index="/home/firstPayStatistics"
                v-if="hasPermission('首次付费转化率')"
                >首次付费转化率
              </el-menu-item>
            </el-submenu>

            <el-submenu v-if="hasPermission('优惠券管理')" index="12">
              <template slot="title">
                <i class="el-icon-document-delete"></i>
                <span slot="title">优惠券管理</span>
              </template>
              <el-menu-item index="/home/voucher">优惠券管理</el-menu-item>
              <el-menu-item 
                v-if="hasPermission('优惠券订单列表')"
                index="/home/voucherOrder">优惠券订单列表</el-menu-item>
            </el-submenu>

            <el-submenu v-if="hasPermission('用户登陆列表')" index="13">
              <template slot="title">
                <i class="el-icon-document-delete"></i>
                <span slot="title">登陆日志</span>
              </template>
              <el-menu-item index="/home/loginLog">登陆日志</el-menu-item>
            </el-submenu>

            <el-submenu v-if="hasPermission('公司主体列表')"  index="14">
              <template slot="title">
                <i class="el-icon-document-delete"></i>
                <span slot="title">主体管理</span>
              </template>
              <el-menu-item index="/home/mainBody">主体管理</el-menu-item>
            </el-submenu>
            <el-submenu  v-if="hasPermission('企业微信')" index="15">
              <template slot="title">
                <i class="el-icon-edit"></i>
                <span slot="title">企业微信记录</span>
              </template>
              <el-menu-item
                v-if="hasPermission('单聊列表')"
                index="/home/privateChat">私聊</el-menu-item>
              <el-menu-item
                v-if="hasPermission('群聊列表')"
                index="/home/groupChat">群聊</el-menu-item>
              <el-menu-item
                v-if="hasPermission('sop召回流水')"
                index="/home/sopRecall">sop召回流水</el-menu-item>
              <el-menu-item
                v-if="hasPermission('sop召回流水(轮虫)')"
                index="/home/sopRecallLC">sop召回流水(轮虫)</el-menu-item>
            </el-submenu>

            <el-submenu index="16"
                v-if="hasPermission('代币管理')">
              <template slot="title">
                <i class="el-icon-document-delete"></i>
                <span slot="title">代币管理</span>
              </template>
              <el-menu-item index="/home/coinManager"
                v-if="hasPermission('代币设置列表')">代币购买</el-menu-item>
              <el-menu-item 
                index="/home/coinOrder"
                v-if="hasPermission('代币订单列表')">代币订单列表</el-menu-item>
              <el-menu-item index="/home/coinLog"
                v-if="hasPermission('代币使用详情')">代币使用详情</el-menu-item>
            </el-submenu>

          </el-menu>
        </div>
        <el-main :style="{ left: size + platformSize + 'px' }">
          <el-tabs
            v-model="activeTab"
            type="card"
            @tab-remove="removeTab"
            @tab-click="tabClick"
          >
            <el-tab-pane
              v-for="item in tabsItem"
              :key="item.name"
              :label="item.title"
              :name="item.name"
              :closable="item.closable"
              :ref="item.ref"
            >
            </el-tab-pane>
          </el-tabs>
          <template 
            v-for="item in platformUserList">
            <div 
              v-show="showCurrentUser(item)"
              :key="item.value + '_' + item.id">
              <keep-alive
                :include="tabsName"
                :key="item.value + '_' + item.id">
                <router-view
                  v-if="isRouterAlive && showCurrentUser(item)"></router-view>
              </keep-alive>
            </div>
          </template>
          <!-- <el-menu-item-group v-if="platformUserList && platformUserList.length">
            <el-menu-item
              v-for="item in platformUserList"
              :key="item.value + '_' + item.id"
              :index="item.value + '_' + item.id"
              @click="toggleUser(item)"
              :class="{'platform-active': isPlatformCurrent(item)}">
                {{item.label}}--{{item.username}}
              </el-menu-item>
            <el-menu-item
              index="loginAdd"
              @click="loginAdd()">
                添加账号
              </el-menu-item>
          </el-menu-item-group>
          <keep-alive :include="tabsName">
            <router-view v-if="isRouterAlive" :key="routeKey"></router-view>
          </keep-alive> -->
        </el-main>
      </el-container>

      <el-drawer
        size="280"
        title="游戏包上传任务"
        :visible.sync="showGamePackagesUploadTasks"
        :direction="direction"
        :before-close="handleTasksClose"
      >
        <div style="overflow-y: scroll">
          <div
            class="task"
            v-for="(item, index) in gamePackagesUploadTasks"
            style="padding: 10px 20px"
            :key="index"
          >
            <div>
              <el-upload
                :id="item.taskId"
                class="upload-demo"
                :ref="item.taskId"
                action=""
                drag
                :show-file-list="false"
                :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, item);
                  }
                "
                :limit="1"
                :auto-upload="false"
              >
                <div
                  style="
                    height: 100%;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                  "
                >
                  <div style="font-size: 14px; color: orange; font-weight: bold">
                    《{{ item.name }}》
                  </div>
                  <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                  </div>
                </div>
              </el-upload>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-top: 10px;
                "
              >
                <div>{{ taskUploadStatus(item.uploadStatus) }}</div>
                <el-progress
                  v-if="progress && progress[item.taskId]"
                  style="width: 100px;"
                  :text-inside="true"
                  :stroke-width="18"
                  :percentage="progress[item.taskId]"></el-progress>
                <div>
                  <el-button
                    @click="removeUploadTasks(item)"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                  ></el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
    </el-container>

  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import fetch from "@/assets/js/axios.js";
import welcome from "./index/index";
import _ from 'lodash'
import COS from '@/assets/js/cos-js-sdk-v5.min.js'

export default {
  name: "home",
  components: {},
  data() {
    return {
      dialogLoginVisible: false,
      platformCollapse: false,
      currentAdmin: {},
      dialogSmsVisible: false,
      sendCount: 60,
      currentIndex: '',
      smsSending: false,
      superAdminList: [],
      dialogVisible: false,
      size: 200,
      isCollapse: false,
      num: 1,
      isRouterAlive: true,

      tabIndex: 1, //tab目前显示数
      activeTab: "1", //默认显示的tab
      menuList: [],
      tabsItem: [
        {
          title: "首页",
          name: "index",
          closable: false,
          ref: "tabs",
          content: welcome,
        },
      ],
      tabsName: ["index"],
      tabsPath: [
        {
          name: "index",
          path: "index",
        },
      ],
      direction: "rtl",
      // 游戏包上传进度
      progress: {},
      showContainer: false,
    };
  },
  created() {
    this.menuAuth();
    this.getSuperAdminList()
    if (sessionStorage.getItem('tab_bus')) {
      const {
        tabsItem,
        tabsName,
        activeTab,
        tabsPath
      } = JSON.parse(sessionStorage.getItem('tab_bus'))
      this.tabsItem = tabsItem
      this.tabsName = tabsName
      this.activeTab = activeTab
      this.tabsPath = tabsPath
    }
  },
  mounted () {
    this.$bus.$on('updateCurrentUser', this.addCurrentUser)
    this.$bus.$on('updateCurrentTab', this.setCurrentUserTab)
    this.$bus.$on('getMagic', this.getMagic)
    this.getMagic()
  },
  computed: {
    showSuperRole () {
      return this.currentPlatformUser && this.currentPlatformUser.role_id === 1
    },
    routeKey () {
      const { value, id } = this.currentPlatformUser
      return `${value}_${id}_${this.activeTab}`
    },
    platformSize () {
      return this.platformCollapse ? 64 : 150
    },
    setHeight() {
      return document.documentElement.clientHeight - 65;
    },
    activeNav() {
      //当前激活的导航
      return this.$route.path;
    },
    ...mapState(["admin", "exportDownloadPercent"]),
    ...mapState([
      "platform",
      "logoText",
      "showGamePackagesUploadTasks",
      "gamePackagesUploadTasks",
      "platformUserList",
      "currentPlatformUser",
      "showLogin"
    ]),
    taskUploadStatus() {
      return (status) => {
        switch (status) {
          case 0:
            return "未上传";
          case 1:
            return "上传中";
          case 2:
            return "上传失败";
          case 3:
            return "上传成功";
        }
      };
    },
  },
  watch: {
    $route: function (to) {
      //监听路由的变化，动态生成tabs
      let flag = true; //判断是否需要新增页面
      const path = to.path;
      this.activeTab = "1";
      if (Object.keys(to.meta).length > 1) {
        for (let i = 0; i < this.$refs.tabs.length; i++) {
          if (i != 0) {
            //首页不判断 如果页面已存在，则直接定位当页面，否则新增tab页面
            if (this.$refs.tabs[i].label == to.meta.name) {
              this.activeTab = this.$refs.tabs[i].name; //定位到已打开页面
              flag = false;
              break;
            }
          }
        }
        //新增页面
        if (flag) {
          //获得路由元数据的name和组件名
          const thisName = to.meta.name;
          const thisComp = to.meta.comp;
          //对tabs的当前激活下标和tabs数量进行自加
          // let newActiveIndex = ++this.tabIndex + "";
          //动态双向追加tabs
          this.tabsItem.push({
            title: thisName,
            name: to.name,
            closable: true,
            ref: "tabs",
            content: thisComp,
          });
          this.tabsName.push(to.name);
          this.activeTab = to.name;
          /*
           * 当添加tabs的时候，把当前tabs的name作为key，path作为value存入tabsPath数组中
           * key:tabs的name
           * value:tabs的path
           * {
           *   key: name,
           *   value: path
           * }
           * ///后面需要得到当前tabs的时候可以通过当前tabs的name获得path
           * */
          if (this.tabsPath.indexOf(path) == -1) {
            this.tabsPath.push({
              name: to.name,
              path: path,
            });
          }
          this.setTabBus()
        }
      }
    },
    showLogin: function () {
      this.dialogLoginVisible = true
    }
  },
  methods: {
    ...mapMutations([
      "setPermissions",
      "removeTasks",
      "changeShowGamePackagesUploadTasks",
      "changeTask",
      "setCurrentPlatform",
      "removeUser",
      "addCurrentUserParams",
      "setMAGIC",
    ]),
    getMagic () {
      fetch({
        url: 'admin/system/magic',
        method: 'GET',
      }).then(res => {
        if (res.data.status && res.data.data) {
          const { MAGIC } = res.data.data
          this.setMAGIC(MAGIC)
        }
      })
    },
    setTabBus () {
      const tab_bus = {
        tabsItem: this.tabsItem,
        tabsName: this.tabsName,
        activeTab: this.activeTab,
        tabsPath: this.tabsPath
      }
      sessionStorage.setItem('tab_bus', JSON.stringify(tab_bus))
    },
    showCurrentUser (item) {
      let flag = false
      const { value, id } = this.currentPlatformUser
      if (item.value === value && item.id === id) flag = true
      return flag
    },
    loginAdd () {
      // sessionStorage.removeItem("access_token");
      // sessionStorage.removeItem("access_token_expired_at");
      // this.$router.push("/");
      this.dialogLoginVisible = true
    },
    // 切换主体账号
    async toggleUser (item) {
      await this.addCurrentUser()
      await this.setCurrentPlatform(item)
      await this.setCurrentUserTab()
      this.getMagic()
      this.setTabBus()
      this.menuAuth()
    },
    setCurrentUserTab () {
      const {
        tabsItem,
        tabsName,
        activeTab,
        tabsPath
      } = this.currentPlatformUser
      if (!activeTab) {
        this.activeTab =  "1"
        this.tabsItem = [
          {
            title: "首页",
            name: "index",
            closable: false,
            ref: "tabs",
            content: welcome,
          },
        ]
        this.tabsName = ["index"]
        this.tabsPath = [
          {
            name: "index",
            path: "index",
          },
        ]
      } else {
        this.tabsItem = _.cloneDeep(tabsItem)
        this.tabsName = _.cloneDeep(tabsName)
        this.activeTab = _.cloneDeep(activeTab)
        this.tabsPath = _.cloneDeep(tabsPath)
      }
    },
    async addCurrentUser () {
      const { path: lastRoute } = this.$route
      await this.addCurrentUserParams({
        lastRoute,
        tabsItem: _.cloneDeep(this.tabsItem),
        tabsName: _.cloneDeep(this.tabsName),
        activeTab: _.cloneDeep(this.activeTab),
        tabsPath: _.cloneDeep(this.tabsPath)
      })
    },
    isPlatformCurrent (item) {
      return this.currentPlatformUser.value === item.value && this.currentPlatformUser.id === item.id
    },
    // ...mapActions(['hasPermission']),
    // 发送验证码获取授权
    sendSms (phonenum, index) {
      this.smsSending = true
      this.currentIndex = index
      let interval = setInterval(() => {
        if (this.sendCount < 1) {
          this.sendCount = 60
          this.smsSending = false
          clearInterval(interval)
        } else {
          this.sendCount -= 1
        }
      }, 1000)
      fetch({
        url: '/admin/authorizations/sms',
        method: 'GET',
        params: {
          phone: phonenum,
          company: this.platform
        }
      }).then(res => {
        if (res.data.status) {
          this.currentAdmin = {
            code: '',
            phone: phonenum 
          }
          this.dialogSmsVisible = true
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取超级权限
    getSuperToken () {
      const data = this.currentAdmin
      if (data.code.length === 0) {
        this.$message.error('请输入验证码')
        return
      }
      fetch({
        url: '/admin/authorizations/grant_super',
        method: 'POST',
        data
      }).then(res => {
        if (res.data.status) {
          localStorage.setItem("super_token", res.data.data.token);
          localStorage.setItem("super_token_expired_at", res.data.data.expired_at);
          this.addCurrentUserParams({
            super_token: res.data.data.token,
            super_token_expired_at: res.data.data.expired_at
          })
          this.dialogSmsVisible = false
          this.dialogVisible = false
          this.$message.success('获取超级权限成功')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取超级管理员列表
    getSuperAdminList () {
      fetch({
        url: '/admin/authorizations/supers',
        method: 'GET'
      }).then(res => {
        if (res.data.status) {
          const data = res.data.data
          const list = []
          for (const key in data) {
            list.push({
              phonenum: key,
              name: data[key]
            })
          }
          this.superAdminList = list
        }
      })
    },
    // 用户菜单权限
    menuAuth() {
      if (sessionStorage.getItem("access_token")) {
        //只有登录成功了，并且有token，才会执行下一步

        // 调用接口
        fetch({
          url: "admin/admin/allow",
          methods: "GET",
        })
          .then((res) => {
            // 成功的操作
            if (res.data.status) {
              // let object = {};
              // let that = this;
              this.menuList = res.data.data.menu;

              // 是否展示列表
              window.displayList = res.data.data.display_list

              // 是否展示所属渠道
              window.displayChannel = res.data.data.display_channel
              // 是否展示所属游戏
              window.displayGame = res.data.data.display_game

              // 是否允许导出
              window.canExport = res.data.data.export

              let permissions = [];

              this.menuList.forEach((item, index) => {
                permissions.push(item.menu_name);

                // for (var i = 0; i < that.menu.length; i++) {
                //   if (that.menu[i] == item["menu_name"]) {
                //     let arr = [];
                //     arr["name"] = item["menu_name"];
                //     arr["action"] = that.menuPath[i];
                //     // arr['action'] = '/home/' + item['action'];
                //     if (item["parentid"] == 0) {
                //       arr["children"] = [];
                //       object[item.id] = arr;
                //     } else {
                //       object[item.parentid]["children"].push(arr);
                //     }
                //   }
                // }
              });
              this.setPermissions(permissions);
            }
          })
          .finally(() => {
            this.showContainer = true
          });
      } else {
        next({
          path: "/",
        });
      }
    },
    logout() {
      this.$message.success('退出账号中，请稍候。')
      fetch({
        url: "/admin/authorizations/destroy",
        method: "POST",
      }).finally(async () => {
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("access_token_expired_at");
        localStorage.removeItem("username");
        localStorage.removeItem("password");
        await this.removeUser()
        if (this.platformUserList && this.platformUserList.length) {
          this.setCurrentPlatform(this.platformUserList[0])
        } else {
          sessionStorage.removeItem('tab_bus')
          sessionStorage.removeItem('lastRoute')
          this.$router.push("/");
        }
      });
    },
    zoom() {
      if (this.num == 1) {
        this.isCollapse = true;
        this.size = 64;
        this.num = 2;
      } else {
        this.isCollapse = false;
        this.size = 200;
        this.num = 1;
      }
    },

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    handleSelect(index) {
      if (index === this.$route.path) {
        this.reload();
      }
    },

    removeTab(targetName) {
      //删除Tab
      let tabs = this.tabsItem; //当前显示的tab数组
      let activeName = this.activeTab; //点前活跃的tab

      //如果当前tab正活跃 被删除时执行
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
              this.tabClick(nextTab);
            }
          }
        });
      }
      this.activeTab = activeName;
      this.tabsItem = tabs.filter((tab) => tab.name !== targetName);
      this.tabsName = this.tabsName.filter((tab) => tab !== targetName);

      //在tabsPath中删除当前被删除tab的path
      this.tabsPath = this.tabsPath.filter(item => item.name !== targetName)
      this.setTabBus()
    },
    tabClick(thisTab) {
      /*
       * thisTab:当前选中的tabs的实例
       * 通过当前选中tabs的实例获得当前实例的path 重新定位路由
       * */
      let val = this.tabsPath.filter((item) => thisTab.name == item.name);
      this.$router.push({
        path: val[0].path,
      });
    },
    handleTasksClose() {
      this.changeShowGamePackagesUploadTasks(false);
    },
    beforeUpload(file, item) {},
    handleChange(file, fileList, item) {
      const vm = this
      if (file && file.status === "ready") {
        const suffix = file?.name.match(/[^.]+$/g)[0]
        fetch({
          url: "/admin/game_packages/cos_upload_key",
          method: "GET",
          params: {
            game_package_id: item.id,
            suffix
          },
        }).then((res) => {
          const { authorization, bucket, key, region, domain } = res.data.data
          const cos = new COS({
            // getAuthorization 必选参数
            getAuthorization: function (options, callback) {
              callback({
                TmpSecretId: authorization.credentials.tmpSecretId,
                TmpSecretKey: authorization.credentials.tmpSecretKey,
                SecurityToken: authorization.credentials.sessionToken,
                // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                StartTime: authorization.startTime, // 时间戳，单位秒，如：1580000000
                ExpiredTime: authorization.expiredTime, // 时间戳，单位秒，如：1580000000
              })
            },
            UseAccelerate: true,
          });

          item.uploadConfig = res.data.data
          item.uploadStatus = 1
          item.file = file
          const progress = this.progress
          progress[item.taskId] = 0
          this.progress = progress
          this.changeTask(item)

          cos.uploadFile({
            Bucket: bucket, /* 填入您自己的存储桶，必须字段 */
            Region: region,  /* 存储桶所在地域，例如ap-beijing，必须字段 */
            Key: key,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
            Body: file.raw, /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */
            SliceSize: 1024 * 1024 * 5,      /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
            AsyncLimit: 10,
            onProgress: function (progressData) {
              if (vm.progress) {
                const progress = vm.progress
                progress[item.taskId] = Math.ceil(progressData.percent * 100)
                vm.progress = progress
                vm.$forceUpdate()
              }
            },
            onFileFinish: function (err) {
              if (err) {
                vm.onUploadError(item)
              } else {
                vm.onUploadSuccess(cos, {item, file_size: file.size}, {bucket, key, region, domain})
              }
            },
          }, function(err, data) {
            // console.log(err || data)
          })
        });
      }
    },
    onUploadSuccess(cos, {item, file_size}, {bucket, key, region, domain}) {
      const vm = this
      cos.getObjectUrl(
        {
          Bucket: bucket, // 填入您自己的存储桶，必须字段
          Region: region, // 存储桶所在地域，例如 ap-beijing，必须字段
          Key: key, // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），支持中文，必须字段
          Domain: domain, // 获取带签名的对象 URL
        },
        function (err, data) {
          if (err) return console.log(err);
          const url = data?.Url?.split('?')[0]
          if (!url) {
            vm.onUploadError(item)
            return
          }
          fetch({
            url: "/callback/upload/tencent",
            method: "GET",
            params: {
              game_package_id: item.id,
              file_size,
              url
            },
          }).then((res) => {
            if (res.data.status) {
              vm.removeTasks(item.taskId);
              vm.$message({
                type: "success",
                message: `母包[${item.name}] - 上传成功`,
                duration: 0,
                showClose: true,
              })
            }
          })
        }
      )
    },
    removeUploadTasks(task) {
      let vm = this;
      vm.$refs[task.taskId][0].clearFiles();
      if (task.file) {
        vm.$refs[task.taskId][0].abort(task.file);
      }
      this.removeTasks(task.taskId);
    },
    onUploadError(item) {
      item.uploadStatus = 2
      this.changeTask(item)
      this.$message({
        type: "error",
        message: `母包[${item.name}] - 上传失败`,
        duration: 0,
        showClose: true,
      })
      this.$refs[item.taskId][0].clearFiles()
    },
  },
};
</script>
<style lang="less">
#admin {
  display: flex;
}
.logoFont {
  font-size: 38px;
  color: #ccc;
  font-weight: 100;
  margin-left: 20px;
}
.admin {
  color: #ccc;
  margin-right: 10px;
}
.admin-setting {
  color: #ccc;
  margin-right: 15px;
}
.el-main {
  overflow-y: auto;
  position: fixed;
  top: 60px;
  right: 0;
  bottom: 0;
}
.el-main > div {
  height: 60px;
}
.router-link {
  text-decoration: none;
}
// 顶部
.menu-hd {
  width: 100%;
  height: 60px;
  .hd-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    background: #23262e;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
}
// 左侧边栏
.menu-left {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 48px;
  box-sizing: border-box;
  overflow-x: hidden;
  background: #282b33;
  z-index: 100;
}
.el-menu {
  background: #282b33;
  border-right: none;
}
.aside-left {
  position: relative;
  background: #282b33;
  box-sizing: border-box;
  height: 100%;
  overflow-x: hidden;
}
.aside-left::-webkit-scrollbar {
  width: 0 !important;
}
.el-submenu__icon-arrow {
  margin-top: -4px;
}
.el-menu-item,
.el-submenu__title {
  color: #fff;
}
.el-menu-item,
.el-submenu__title {
  opacity: 0.6;
  background: #282b33;
  &:hover {
    background: #282b33;
    opacity: 1;
  }
}
.el-menu-item.is-active {
  background: #393d49;
  opacity: 1;
  color: #fff;
  &:hover {
    background: #4e5465;
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}
.el-sider-trigger {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
  height: 48px;
  box-sizing: border-box;
  color: #fff;
  line-height: 48px;
  text-align: center;
  background: #23262e;
  cursor: pointer;
  transition: all 0.4s;
  overflow: hidden;
}
.v-modal {
  display: none;
}
.el-upload-dragger {
  width: 240px;
  height: 100px;
}
.task {
  padding-bottom: 20px;
  border-bottom: 1px dashed #606266;
}
.task:last-child {
  border-bottom: 0;
}
.el-drawer__body {
  overflow-y: scroll;
}

.platform-active {
  color: #409EFF!important;
}
</style>
